import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.DepositoBancoDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Pendiente de contabilizar", cell: x => ({ data: x.PendienteContabilizar }) },
    { title: "Usuario", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Fecha desde", cell: x => ({ data: kea.toDate(x.FechaDepositoAnterior) }) },
    { title: "Fecha hasta", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Importe (Documentación, ocurre y EAD)", cell: x => ({ data: kea.formatCurrency(x.ImporteDeposito) }) },


    { title: "ImporteGuiasPP", cell: x => ({ data: kea.formatCurrency(x.ImporteGuiasPP) }) },
    { title: "ImporteTotal", cell: x => ({ data: kea.formatCurrency(x.ImporteTotal) }) },
];

export interface BotonesDeps {
    onContabilizar: (item: Entity) => void;
    onConsultar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const ultimoMayo = new Date(2018, 4, 31, 23, 59);
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Consultar",
            style: "info",
            iconClass: fa("eye"),
            disabled: x => x.PendienteContabilizar,
            onClick: deps.onConsultar
        },
        {
            tooltip: "Contabilizar",
            style: "primary",
            iconClass: fa("reply-all"),
            disabled: x => !x.PendienteContabilizar || new Date(x.Fecha as Date) < ultimoMayo,
            onClick: deps.onContabilizar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "300px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/depositobanco/list/columns.tsx